import { Component, OnInit } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-affiliate-withdrawal-page',
  templateUrl: './user-profile-affiliate-withdrawal-page.component.html',
  styleUrls: ['./user-profile-affiliate-withdrawal-page.component.scss'],
})
export class UserProfileAffiliateWithdrawalPageComponent implements OnInit {
  constructor(
    private api: UserApiService,
    private message: MessageService
  ) {
  }

  loginID = '';
  name = '';
  amount = 0;
  affiliate: any;
  withdrawals: any[] = [];
  ngOnInit(): void {
    this.getUserAffiliate();
    this.findUserAffiliateWithdrawals();
  }

  async findUserAffiliateWithdrawals() {
    try {
      const r = await this.api.findUserAffiliateWithdrawals(1, 20);
      this.withdrawals = r.data.list;
    } catch (error) {}
  }

  loading = false;
  async getUserAffiliate() {
    try {
      this.loading = true;
      const r = await this.api.getUserAffiliate();
      this.affiliate = r.data;
      this.amount = this.affiliate.available_commission;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  onOk() {
    this.loginID = this.loginID.trim();
    this.name = this.name.trim();
    if (!this.loginID || !this.name) {
      this.message.warn('请填写支付宝账号和姓名');
      return;
    }
    if (this.amount > this.affiliate.available_commission) {
      this.message.warn('提现金额超过最大可提现金额');
      return;
    } else if (this.amount > 5000) {
      this.message.warn('单次最大提取5000元');
      return;
    } else if (this.amount < 0.1) {
      this.message.warn('单次最少提现0.1元');
      return;
    }
    this.withdraw();
  }

  async withdraw() {
    try {
      this.loading = true;
      const r = await this.api.createUserAffiliateWithdrawalAlipay(
        this.loginID,
        this.name,
        this.amount
      );
      if (r.status === 1008) {
        this.message.warn('提现金额有误');
      } else if (r.status === 1012) {
        this.message.warn('支付宝账号不存在，请确认后再操作');
      } else if (r.status === 1013) {
        this.message.warn('转账失败');
      } else if (r.status !== 0) {
        this.message.warn('未知错误');
      } else {
        this.message.open('提现成功，请检查您的支付宝');
        this.getUserAffiliate();
        this.findUserAffiliateWithdrawals();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  displayedColumns: string[] = ['time', 'method', 'account', 'amount'];
}
